import { IVehicleTuningShopItem } from '~/rage';
import {
	IVehicleWheelsSettings,
	VehicleTuningCategory,
	VehicleWheelsSetting,
} from '~/shared';
import { createSlice } from '../wrappers';

export interface TuningSlice {
	activeStage: 'category' | 'list' | 'wheel_settings';
	activeCategory: VehicleTuningCategory | null;
	maxCategoryIndex: number;
	activeList: IVehicleTuningShopItem[];
	activeListIndex: number | null;
	maxListIndex: number;
	wheelSettings: IVehicleWheelsSettings;
	shopItems: IVehicleTuningShopItem[];
}

const initialState: TuningSlice = {
	activeStage: 'category',
	activeCategory: null,
	maxCategoryIndex: 7,
	activeList: [] as IVehicleTuningShopItem[],
	activeListIndex: null,
	maxListIndex: 0,
	wheelSettings: {
		[VehicleWheelsSetting.FRONT_CAMBER]: 1,
		[VehicleWheelsSetting.REAR_CAMBER]: 1,
		[VehicleWheelsSetting.FRONT_OFFSET]: 1,
		[VehicleWheelsSetting.REAR_OFFSET]: 1,
		[VehicleWheelsSetting.RADIUS]: 1,
		[VehicleWheelsSetting.WIDTH]: 1,
	},
	shopItems: [],
};

const tuningSlice = createSlice({
	name: 'tuning',
	initialState,
	reducers: {
		setActiveListIndex: (state, action) => {
			state.activeListIndex = action.payload;
		},
		setMaxListIndex: (state, action) => {
			state.maxListIndex = action.payload;
		},
		setActiveList: (state, action) => {
			state.activeList = action.payload;
		},
		setActiveCategory: (state, action) => {
			state.activeCategory = action.payload;
		},
		setWheelSettings: (state, action) => {
			state.wheelSettings = action.payload;
		},
		setShopItems: (state, action) => {
			state.shopItems = action.payload;
		},
	},
});

export const {
	setActiveListIndex,
	setMaxListIndex,
	setActiveList,
	setActiveCategory,
	// setWheelSettings,
	setShopItems,
} = tuningSlice.actions;

export default tuningSlice.reducer;
